import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function DemographicsIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.66406 11.9993C6.87306 10.6969 9.10873 10.6355 10.3307 11.9993M9.29113 7.99935C9.29113 8.73575 8.70993 9.33268 7.993 9.33268C7.27606 9.33268 6.69486 8.73575 6.69486 7.99935C6.69486 7.26295 7.27606 6.66602 7.993 6.66602C8.70993 6.66602 9.29113 7.26295 9.29113 7.99935Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M6.33008 2.66797C4.56715 2.67454 3.62408 2.73618 3.0135 3.31464C2.33008 3.96208 2.33008 5.00414 2.33008 7.08827V10.2461C2.33008 12.3303 2.33008 13.3723 3.0135 14.0197C3.69691 14.6672 4.79686 14.6672 6.99674 14.6672H8.99674C11.1966 14.6672 12.2965 14.6672 12.98 14.0197C13.6634 13.3723 13.6634 12.3303 13.6634 10.2461V7.08827C13.6634 5.00414 13.6634 3.96208 12.98 3.31464C12.3694 2.73618 11.4263 2.67454 9.66341 2.66797"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M6.51152 2.42174C6.57548 2.1452 6.60746 2.00693 6.66888 1.89401C6.81201 1.63096 7.07594 1.43764 7.39101 1.36512C7.52628 1.33398 7.68314 1.33398 7.99674 1.33398C8.31034 1.33398 8.46721 1.33398 8.60248 1.36512C8.91754 1.43764 9.18148 1.63095 9.32461 1.89401C9.38601 2.00693 9.41801 2.1452 9.48194 2.42174L9.53748 2.66182C9.65094 3.15228 9.70768 3.3975 9.62208 3.58614C9.56668 3.70832 9.47221 3.81293 9.35074 3.88672C9.16314 4.00065 8.88501 4.00065 8.32881 4.00065H7.66468C7.10848 4.00065 6.83034 4.00065 6.64275 3.88672C6.52126 3.81293 6.42681 3.70832 6.37139 3.58614C6.28582 3.3975 6.34254 3.15228 6.45598 2.66182L6.51152 2.42174Z"
        stroke="currentColor"
        fill="none"
      />
    </SvgIcon>
  );
}
